import { render, staticRenderFns } from "./_base-video.vue?vue&type=template&id=7d1ddd7c&"
import script from "./_base-video.vue?vue&type=script&lang=js&"
export * from "./_base-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports